module.exports = __webpack_public_path__ + "assets/media/w1_1.33013dcf.mp4";